import { useLenis } from "@/hooks/useLenis";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Marquee } from "@/components/Marquee";
import { Scene3D } from "@/components/Scene3D";
import { ToolsMarquee } from "@/components/ToolsMarquee";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { Hero } from "@/sections/Hero";
import { Solucoes } from "@/sections/Solucoes";
import { Economize } from "@/sections/Economize";
import { Metodo } from "@/sections/Metodo";
import { Contato } from "@/sections/Contato";
import { Footer } from "@/sections/Footer";

export function HomePage() {
  useLenis();

  return (
    <div className="App min-h-screen bg-[#05070D] font-sora text-slate-200 antialiased">
      <Scene3D />
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Solucoes />
          <ToolsMarquee />
          <Economize />
          <Metodo />
          {/* <Portfolio /> volta quando tiver portfólio real */}
          <Contato />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </div>
  );
}
